import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import {
  Button,
  CardContent,
  Snackbar,
} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Edit } from "@material-ui/icons";
import { AgGridReact } from "ag-grid-react";
import UserFormModal from './UserFormModal';
import DeleteCellRenderer from "./deleteCellRenderer";
import MuiAlert from "@material-ui/lab/Alert";
import api from "../../utils/api";
const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 645,
    backgroundImage:
      "linear-gradient(to right, rgba(00, 92, 73,1), rgb(10, 36, 26))",
  },
  table: {
    minWidth: 500,
    height: 300,
    overflowY: "auto",
  },
  paperContainer1: {
    backgroundImage: `linear-gradient(to right bottom, rgba(255,255,255,.1), rgba(255,255,255,.1)), url(${require("../../assets/img/topBack.jpg")})`,
    backgroundPosition: "0,0",
    backgroundColor: "#174C38",
    padding: "20px",
    marginBottom: 20,
    "@media screen and (max-width: 576px)": {
      padding: 10,
    },
  },
  GridContainer: {
    minHeight: 356,
    minWidth: 900,
    backgroundPosition: "0,0",
    marginBottom: 20,
  },
  textSecondary: {
    color: "#ffffff",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  memeberGrid: {
    display: "grid",
    gap: 10,
    gridTemplateColumns: "1fr",
    "@media screen and (max-width: 576px)": {
      gridTemplateColumns: "1fr",
    },
  },
  tabsRoot: {
    backgroundColor: '#e0e0e0',
    borderRadius: theme.shape.borderRadius,
    minHeight: 48,
  },
  tabRoot: {
    fontWeight: 'bold',
    color: '#333',
    minWidth: 120,
    '&$tabSelected': {
      color: theme.palette.primary.main,
    },
  },
  tabSelected: {},

  tabsIndicator: {
    backgroundColor: theme.palette.primary.main,
  },
}));

const UserMasterContent = () => {
  const classes = useStyles();
  const gridRef = useRef();
  let gridApi = React.useRef(null);

  const APIBASE_URL = useMemo(() => process.env.REACT_APP_APIBASE_URL, []);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [addedNewUser, setAddedNewUser] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    // Fetch users from an API or local storage
    const fetchUsers = async () => {
      // Replace with actual data fetching logic
      const userData = await api.get(APIBASE_URL + "/getGreenablUsers");
      setUsers(userData.data);
    };
    fetchUsers();
  }, [addedNewUser]);

  const handleAddUser = async (user) => {
    try {
      const response = await fetch(`${APIBASE_URL}/insertOrUpdateGreenablUser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
      });
      if (response.ok) {
        const result = await response.json();
        if (result.Success === 0 && result.Message) {
          setSnackbarMsg(result.Message);
          setSnackbarSeverity("error"); // <-- show red error
          setSnackbarOpen(true);
        } else {
          setUsers([result, ...users]);
          setIsModalOpen(false);
          setSnackbarMsg("User added successfully!");
          setSnackbarSeverity("success"); // <-- show green success
          setSnackbarOpen(true);
        }
      } else {
        alert("Failed to add user.");
      }
    } catch (error) {
      alert("Error adding user.");
    }
  };

  function updateData() {
    setAddedNewUser(true);
  }

  const handleUpdateUser = (updatedUser) => {
    setUsers(users.map(user => (user.UniqueKey === updatedUser.UniqueKey ? updatedUser : user)));
    setIsModalOpen(false);
  };

  const openModal = () => {
    setSelectedUser(null);
    setIsModalOpen(true);
  };

  const gridReady = (params) => {
    gridApi.current = params.api;
    this.gridColumnApi = params.columnApi;
    gridApi.current.sizeColumnsToFit();
  };

  const editButton = (props) => {
    const handleEditClick = () => {
      setSelectedUser(props.data);
      setIsModalOpen(true);
    };
    return (
      <Button onClick={handleEditClick}>
        <Edit />
      </Button>
    );
  };

    const onPageSizeChanged = useCallback(() => {
      var value = document.getElementById("page-size").value;
      gridRef.current.api.paginationSetPageSize(Number(value));
    }, []);
  
  const columns = [
    {
      field: "UniqueKey",
      headerName: "Id",
    },
    {
      field: "MemberCode",
      headerName: "Member Code",
    },
    {
      field: "FName",
      headerName: "First Name",
    },
    {
      field: "LName",
      headerName: "Last Name",
    },
    {
      field: "Email",
      headerName: "Email",
    },
    {
      field: "JobTitle",
      headerName: "Job Title",
    },
    {
      field: "PrimaryContact",
      headerName: "Primary Contact",
    },
    {
      field: "Active",
      headerName: "Status",
    },
    {
      field: "UniqueKey",
      headerName: " ",
      cellRenderer: editButton,
      cellRendererParams: {
        setUserDetails,
        setEdit,
      },
      width: 60,
    },
    {
      field: "UniqueKey",
      headerName: " ",
      cellRenderer: DeleteCellRenderer,
      cellRendererParams: {
        update: updateData
      },
      width: 60,
    },
  ];

  return (
    <div>
      <Card className={classes.paperContainer1}>
        <div
          style={{
            backgroundColor: "#fff",
            padding: 10,
            marginBottom: 15,
            borderRadius: 4,
          }}
        >
          <Typography variant="h5" component="h2" align="center">
            User Master
          </Typography>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={openModal}
          >
            Add User
          </Button>
        </div>
        <div className={classes.memeberGrid}>
          <Card>
            <CardContent>
              <div className="example-header">
                Page Size:
                <select
                  onChange={onPageSizeChanged}
                  id="page-size"
                  style={{ marginLeft: 10 }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
              <div
                style={{ height: 475, maxWidth: "100%", overflowX: "auto" }}
                className="ag-theme-alpine"
              >
                <AgGridReact
                  ref={gridRef}
                  columnDefs={columns}
                  rowData={users}
                  rowSelection={"multiple"}
                  rowMultiSelectWithClick={false}
                  defaultColDef={{
                    resizable: true,
                    sortable: true,
                    background: "#f0f0f5",
                    filter: "agTextColumnFilter",
                  }}
                  pagination={true}
                  paginationPageSize={50}
                  onGridReady={gridReady}
                ></AgGridReact>
              </div>
            </CardContent>
          </Card>
        </div>
      </Card>
      <UserFormModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAddUser={handleAddUser}
        onUpdateUser={handleUpdateUser}
        selectedUser={selectedUser}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          elevation={6}
          variant="filled"
        >
          {snackbarMsg}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default UserMasterContent;